import React, { useState } from "react";
import Layout from "../../../components/layout/Layout";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";

export default function AddSubCategory() {
  const [formData, setFormData] = useState({
    name: "",
    title: "",
    description: "",
    image: "",
    orderTimeSlotStart: "",
    orderTimeSlotEnd: "",
    deliveryTimeSlotEnd:"",
    deliveryTimeSlotStart:"",
    notes: ""
  });
  const { id } = useParams();
  const [disableBtn, setDisableBtn] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === "image") {
      setFormData({ ...formData, image: e.target.files[0] });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisableBtn(true);
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      console.log(formData);
      const formdata = new FormData();
      formdata.append("name", formData.name);
      formdata.append("title", formData.title);
      formdata.append("description", formData.description);
      formdata.append("image", formData.image);
      formdata.append("categoryId", id);

      if (id === "6818ed021071326265af20cd") {
        formdata.append("orderTimeSlotStart", formData.orderTimeSlotStart);
        formdata.append("orderTimeSlotEnd", formData.orderTimeSlotEnd);
        formdata.append("deliveryTimeSlotEnd", formData.deliveryTimeSlotEnd);
        formdata.append("deliveryTimeSlotStart", formData.deliveryTimeSlotStart);
        formdata.append("notes", formData.notes);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/subCategory/create-subCategory`,
        formdata,
        { headers }
      );
      if (response.data.statusCode === 200) {
        navigate(-1);
        toast.success(response?.data?.message);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to add Sub Category. Please try again.", error);
    }
    setDisableBtn(false);
  };

  return (
    <>
      <Layout>
        <ToastContainer />
        <div>
          <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Add Sub Category</h2>

              <button
                onClick={() => navigate(-1)}
                className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Back
              </button>

            </div>
            <div className="mt-10" onSubmit={handleSubmit}>
              <form action="">
                <div className="">
                  <label htmlFor="" className="text-sm">
                    Sub Category Name
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                    placeholder="Write Sub Category Name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Sub Category Title
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm "
                    placeholder="Write Sub Category Title"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="" className="text-sm">
                    Sub Category Description
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Write Sub Category Description"
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                    required
                  />
                </div>


                {id === "6818ed021071326265af20cd" && (
                  <>
                    <div className="mt-4 flex flex-col md:flex-row gap-4">
                      <div className="w-full md:w-1/2">
                        <label className="text-sm">Order Time Slot Start</label>
                        <input
                          type="time"
                          className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                          name="orderTimeSlotStart"
                          value={formData.orderTimeSlotStart}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="w-full md:w-1/2">
                        <label className="text-sm">Order Time Slot End</label>
                        <input
                          type="time"
                          className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                          name="orderTimeSlotEnd"
                          value={formData.orderTimeSlotEnd}
                          onChange={handleInputChange}
                        />
                      </div>

                                             <div className="w-full md:w-1/2">
                        <label className="text-sm">Delivery Time Slot  Start</label>
                        <input
                          type="time"
                          className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                          name="deliveryTimeSlotStart"
                          value={formData.deliveryTimeSlotStart}
                          onChange={handleInputChange}
                        />
                      </div>

                      <div className="w-full md:w-1/2">
                        <label className="text-sm">Delivery Time Slot End</label>
                        <input
                          type="time"
                          className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                          name="deliveryTimeSlotEnd"
                          value={formData.deliveryTimeSlotEnd}
                          onChange={handleInputChange}
                        />
                      </div>

                    </div>


                    <div className="mt-4">
                      <label className="text-sm">Notes</label>
                      <input
                        type="text"
                        className="border border-black h-[40px] px-3 w-full mt-1 rounded-sm !outline-none text-sm"
                        placeholder="Enter any notes"
                        name="notes"
                        value={formData.notes}
                        onChange={handleInputChange}
                      />
                    </div>
                  </>
                )}

                {/* Sub Category Image */}
                <div className="mt-4">
                  <label htmlFor="subCategoryImage" className="text-sm">
                    Sub Category Image
                  </label>{" "}
                  <br />
                  <input
                    type="file"
                    className="block w-full text-sm text-slate-800 file:mr-4 file:px-6 file:py-2 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-slate-100 file:text-[#ff4141] cursor-pointer mt-2"
                    placeholder="Choose Picture"
                    name="image"
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-8 text-end">
                  <button
                    type="submit"
                    className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                    disabled={disableBtn}
                  >
                    <i className="fa fa-plus"></i> {disableBtn ? "Adding ..." : "Add Sub Category"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
